import { render, staticRenderFns } from "./inventoryTable.vue?vue&type=template&id=7046c90e&scoped=true&"
import script from "./inventoryTable.vue?vue&type=script&lang=js&"
export * from "./inventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./inventoryTable.vue?vue&type=style&index=0&id=7046c90e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046c90e",
  null
  
)

export default component.exports